import { Moon } from '@lt/components/icons-react';
import React from 'react';
import { formatDateToDayShort } from 'src/utils/dateUtils';
import styled from 'styled-components';
import { useTranslation } from '@lt/localization';
import { TEST_ID_MOBILE_SUMMARY_HOTEL_NIGHTS_TOUR } from './constants';

type Props = {
  startDate: string;
  endDate: string;
  nights: number;
  originalNights: number;
};

const TourNightsCount = ({
  startDate,
  endDate,
  nights,
  originalNights,
}: Props) => {
  const startDateShort = formatDateToDayShort(startDate);
  const endDateShort = formatDateToDayShort(endDate);

  const { t } = useTranslation();

  return (
    <div data-testid={TEST_ID_MOBILE_SUMMARY_HOTEL_NIGHTS_TOUR}>
      <NightsRange>
        {startDateShort} − {endDateShort}
        <NightsCount>
          {nights}
          <MainMoonIcon />
        </NightsCount>
      </NightsRange>
      {nights !== originalNights && (
        <OriginalNights>
          ({originalNights}
          <SecondaryMoonIcon /> {t('checkout.summary.hotel.withFlight')})
        </OriginalNights>
      )}
    </div>
  );
};

const NightsRange = styled.span`
  font-size: 18px;
  font-weight: 700;
`;

const NightsCount = styled.span`
  margin-left: 8px;
`;

const OriginalNights = styled.span`
  font-size: 14px;
  color: #17181a;

  margin-left: 8px;
`;

const MainMoonIcon = styled(Moon)`
  height: 20px;
  vertical-align: sub;
  stroke: #17181a;
`;

const SecondaryMoonIcon = styled(Moon)`
  height: 16px;
  vertical-align: sub;
  fill: #17181a;
`;

export default TourNightsCount;
